<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label for="vpJobId">Vista Job</label>
                    <wj-combo-box
                        id="vpJobId"
                        name="vpJobId"
                        [(ngModel)]="target.vpJobId"
                        [itemsSource]="vpJobOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="vistaJobRequired"
                        [isDisabled]="target.isInternal"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group form-check mt-4">
                    <input
                        id="isInternal"
                        name="isInternal"
                        type="checkbox"
                        class="form-check-input"
                        [(ngModel)]="target.isInternal"
                    />
                    <label class="form-check-label" for="isInternal">Internal / shop bucket</label>
                </div>
                <div class="form-group form-check">
                    <input id="active" name="active" type="checkbox" class="form-check-input" [(ngModel)]="target.active" />
                    <label class="form-check-label" for="active">Active</label>
                </div>
            </div>
        </div>
        @if (target.isInternal) {
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="name">Name</label>
                        <input
                            id="name"
                            name="name"
                            type="text"
                            class="form-control"
                            [(ngModel)]="target.name"
                            required
                        />
                    </div>
                </div>
            </div>
        }
        @if (target.scheduleReference) {
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="scheduleReference">Schedule reference</label>
                        <input
                            id="scheduleReference"
                            name="scheduleReference"
                            type="text"
                            class="form-control"
                            [ngModel]="target.scheduleReference"
                            [ngModelOptions]="{ standalone: true }"
                            readonly
                        />
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
